export default __webpack_public_path__ + "static/setup-toolbar-dark-mode-d4edbe62f31ef6fd4516e6ce95206ea8.mp4";